import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../../pages/customers/customer-control/model/customer';
import { Organization } from '../model/Organization';
import { Orgsettings } from '../model/orgsettings';
import { PersonOrganization } from '../model/personorganization';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': SessionHelper.getIdToken()
  })
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  //personUrl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/';
  
  constructor(private http:HttpClient) { }

  getPersonOrgList(personId:string){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }

    return this.http.get<PersonOrganization[]>(environment.apiUrl+'/person/'+personId+'/organization/mylist',httpOptions);
  }

  login(loginData:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        
      }),
      withCredentials: true
    }

    return this.http.post<any>(environment.apiUrl+'/api/auth/login',JSON.stringify(loginData),httpOptions);
  }
  
  tokenLogin(token:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/api/tokenlogin',JSON.stringify({token:token}),httpOptions);
  }

  getOrgList(){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }

    return this.http.get<Organization[]>(environment.apiUrl+'/organization/list',httpOptions);
  }
  getPerson(orgId:string,personId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }

    return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId,httpOptions);
  }
  getMe() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }

    return this.http.get<any>(environment.apiUrl+'/api/getme',httpOptions);
  }
  // GET /organization/{organizationId}/iscustomer/{userId}
  isCustomer(userId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<string>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/iscustomer/'+userId,httpOptions);
  }
  // /organization/{organizationId}/customer/{customerId}/pit/{pitdate}
  getCustomer(orgId:string,customerId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Customer>(environment.apiUrl+'/organization/'+orgId+'/customer/'+customerId+'/pit/'+new Date().toISOString(),httpOptions);
  }
  getOrg(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Organization>(environment.apiUrl+'/organization/'+orgId,httpOptions)
  }
  getPubOrg(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET      /organization/public/{organizationId}
    return this.http.get<Orgsettings>(environment.apiUrl+'/organization/public/'+orgId,httpOptions)
  }
  getPersonAuth(orgId:string, personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId+'/person/'+personId+'/auth',httpOptions)
  }
  refreshCustomerAuth(orgId:string,customerId:string,userId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //PATCH    /organization/{organizationId}/customer/{customerId}/user/{userId}/refreshauth		worktrest	auth_{userId}	

    return this.http.patch<any>(environment.apiUrl+'/organization/'+orgId+'/customer/'+customerId+'/user/'+userId+'/refreshauth','',httpOptions)
  }
  refreshPersonAuth(orgId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //PATCH    /person/{personId}/orguser/refreshauth	worktrest	auth_{userId}	
    return this.http.patch<any>(environment.apiUrl+'/organization/'+orgId+'/person/'+personId+'/orguser/refreshauth','',httpOptions)
  }
  refreshAdminAuth(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET   /refresh-etadmin-auth
    return this.http.get(environment.apiUrl+'/refresh-etadmin-auth',httpOptions)
  }
  getorgImageUrl(file:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
      const body = '{"Key":"'+file+'"}';
      return this.http.post<any>(environment.apiUrl+'/docstore/getsignedgeturl',body,httpOptions);

   
  }
  getorgImageDB(orgId:string,type:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId+'/image/'+type,httpOptions);
  }
  //get the user settings from the server
  // GET	    /organization/{organizationId}/person/{personId}/settings
  getUserSettings(personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/'+personId+'/settings',httpOptions);
  }
  //Get the organization settings
  // GET	    /organization/{organizationId}/settings
  getOrgSettings(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId+'/settings',httpOptions);
  }
}
